import { useState } from "react";
import AudioJobCreator from "./AudioJobCreator";
import ChooseMethodSelection from "./ChooseMethodSelection";
import FileJobCreator from "./FileJobCreator";

interface IAiJobPositionCreatorProps {
  handleNextStep: () => void;
}

type CreationMethod = "voice" | "file" | null;

const AiJobCreatorStepContent = ({ handleNextStep }: IAiJobPositionCreatorProps) => {
  const [selectedMethod, setSelectedMethod] = useState<CreationMethod>(null);

  return (
    <div className="mx-auto mb-8 w-full">
      {!selectedMethod && (
        <ChooseMethodSelection setSelectedMethod={setSelectedMethod} handleNextStep={handleNextStep} />
      )}
      {selectedMethod === "voice" && (
        <AudioJobCreator handleNextStep={handleNextStep} setSelectedMethod={setSelectedMethod} />
      )}
      {selectedMethod === "file" && (
        <FileJobCreator handleNextStep={handleNextStep} setSelectedMethod={setSelectedMethod} />
      )}
    </div>
  );
};

export default AiJobCreatorStepContent;
